import Page from '../../common/page/page';


class DefaultPage extends Page {

}


export default DefaultPage;
